<dx-scroll-view class="sidebar-scroll-view" [useNative]="false">
  <div class="sidebar">
    <select id="sidebar.change-facility" data-cy="sidebar-change-facility" class="facility-select"
      [(ngModel)]="selectedFacility" (ngModelChange)="changeFacility()">
      @for (facility of facilities; track facility) {
        <option [ngValue]="facility">{{facility.facilityName}}</option>
      }
    </select>
    @for (menuItem of menuItems; track menuItem) {
      <div>
        <!-- If it is a single link -->
        @if (menuItem.menuType === 'link') {
          @if (showMenuItem(menuItem)) {
            <a routerLink="/{{menuItem.menuPath}}" class="single-link"
              routerLinkActive="single-link--selected">
              <i class="material-icons single-link__icon">{{menuItem.iconType}}</i>
              <span class="single-link__title">{{menuItem.title}}</span>
            </a>
          }
        }
        <!-- If it has a submenu -->
        @if (menuItem.menuType === 'sub') {
          <ul class="sidebar__block">
            @if (showMenuItem(menuItem)) {
              <app-sidebar-category id="sidebar.{{menuItem.title}}"
                data-cy="sidebar-{{menuItem.title}}" title="{{menuItem.title}}" icon="{{menuItem.iconType}}">
                @for (childItem of menuItem.children; track childItem) {
                  <div>
                    @if (showSubMenuItem(childItem) && !disableSubMenuItem(childItem)) {
                      <li>
                        <app-sidebar-link id="sidebar.{{childItem.title}}" data-cy="sidebar-{{childItem.title}}"
                          route="/{{menuItem.menuPath}}/{{childItem.menuPath}}">
                          {{childItem.title}}
                        </app-sidebar-link>
                      </li>
                    }
                    @if (disableSubMenuItem(childItem)) {
                      <li>
                        <span class="tooltipx tooltipx--no-underline disabled-sidebar-link">{{childItem.title}}
                          <span class="tooltiptextx tooltiptextx--bottom tooltiptextx--wide">User needs write access for this facility</span>
                        </span>
                      </li>
                    }
                  </div>
                }
              </app-sidebar-category>
            }
          </ul>
        }
      </div>
    }
  </div>
</dx-scroll-view>
